import api from '../axios.js'

export const getPaymentInformation = async (params) => {
	const paramSend = {
		user_id: params.user_id,
	}

	return await api.post('/v2/igx/payment_information',{user_id: params.user_id } ) 
}